import { render, staticRenderFns } from "./PrelimsGroups.vue?vue&type=template&id=7c7f4d74&scoped=true"
import script from "./PrelimsGroups.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrelimsGroups.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PrelimsGroups.vue?vue&type=style&index=0&id=7c7f4d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7f4d74",
  null
  
)

export default component.exports